import { snakeCase, splitByCase } from "scule";
import type { Schema } from "#lib/components/jsonForms/jsonSchema.js";

// match all non alphanumeric/underscore chars
const NOT_ALPHA_NUM_REGEX = /[^a-zA-Z \d_\-.]/g;

// alpha-numerize and snake case a string to make it data property compatible
export function keyFromString(t?: string) {
	return t ? snakeCase(splitByCase(t.replaceAll(NOT_ALPHA_NUM_REGEX, ""), ["-", "_", "/", ".", " "])) : "";
}

export function validateDataPropertyTitle(schema: Schema, title: string, propertyKey?: string): string | undefined {
	if (!title.length) {
		return "Title is required";
	}

	const properties = schema.properties ?? {};
	for (const [key, property] of Object.entries(properties)) {
		if (propertyKey && key === propertyKey) {
			continue;
		}
		if (property.title === title) {
			return "Properties must have unique names";
		}
	}

	const key = keyFromString(title);
	if (key && (!propertyKey || key !== propertyKey) && key in properties) {
		return "Properties must have unique names";
	}

	return undefined;
}
